<template>
    <div class="w-full relative">
        <a class="bg-white text-black p-1 rounded-dropdown flex items-center cursor-pointer" 
            :class="{ 'rounded-b-none': isOpen }" 
            v-click-outside="close"
            @click="toggle">
            <div class="flex-1 px-3 select-none">{{label}}</div>
            <div><button class="btn btn-icon-sm btn-secondary px-6 py-3"><sprite sprite-id="menu-arrow" class="fill-transparent stroke-current align-middle trans-transform" :class="{ 'rotate-180' : isOpen }" /></button></div>
        </a>
        <div v-if="isOpen" class="absolute w-full">
            <ul class="list-reset bg-white rounded-dropdown rounded-t-none shadow">
                <li v-if="allLabel"
                    class="bg-white text-black border-t border-grey-ultralight">
                    <a class="block whitespace-no-wrap overflow-hidden text-overflow-ellipsis px-4 py-3 hover:bg-grey-ultralight cursor-pointer"
                        :title="allLabel"
                        @click="clearSelection()">{{allLabel}}</a>
                </li>
                <li v-for="(option, index) in options" :key="option.value"
                    class="bg-white text-black border-t border-grey-ultralight"
                        :class="index == options.length - 1 ? 'rounded-dropdown rounded-t-none' : ''">
                    <a class="block whitespace-no-wrap overflow-hidden text-overflow-ellipsis px-4 py-3 hover:bg-grey-ultralight cursor-pointer"
                        :class="index == options.length - 1 ? 'rounded-dropdown rounded-t-none' : ''"
                        :title="option.name"
                        @click="selectOption(option)">{{option.name}}</a>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import Sprite from './_Sprite.vue';
import ClickOutside from 'vue-click-outside';

export default {
    name: 'DropdownInput',
    props: ['alias', 'placeholder', 'options', 'value', 'allLabel'],
    data() {
        return {
            isOpen: false
        }
    },
    components: { Sprite },
    directives: { ClickOutside },
    computed: {
        label () {
            return this.value && this.value.alias === this.alias
                ? this.optionsMap[this.value.value].name
                : this.placeholder;
        },
        optionsMap () {
            return this.options.reduce((obj, item) => {
                obj[item.value] = item
                return obj
            }, {});
        }
    },
    methods: {
        toggle () {
            this.isOpen = !this.isOpen;
        },
        close () {
            this.isOpen = false;
        },
        open () {
            this.isOpen = true;
        },
        selectOption (opt) {
            this.$emit('input', { 'alias': this.alias, 'value': opt.value });
            this.close();
        },
        clearSelection () {
            this.$emit('input', false);
            this.close();
        }
    },
    mounted () {
        // prevent click outside event with popupItem.
        this.popupItem = this.$el
    }
}
</script>



// WEBPACK FOOTER //
// src/js/components/_DropdownInput.vue